const cookie = require('browser-cookies')
const userinfo = {
  state: {
    usercode: cookie.get('usercode') || '',
    token: cookie.get('token') || '',
    seed: cookie.get('seed') || '',
    company_id: cookie.get('company_id') || '',
    username: cookie.get('username') || '',
    headimg: cookie.get('headimg') || '',
    compname: cookie.get('compname') || '',
  },
  mutations: {
    SET_TOKEN_DATA: (state, option) => {
      state.usercode = option.usercode
      state.token = option.token
      state.seed = option.seed
      state.company_id = option.company_id
      state.username = decodeURIComponent(option.username)
      state.headimg = option.headimg
      state.compname = option.compname
    }
  },
  actions: {}
}

export default userinfo
